<template>
  <span :class="['tw-inline-flex tw-items-center tw-rounded-full tw-font-normal tw-whitespace-nowrap', colorClass, sizeClass]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary", "red", "green", "gray", "yellow"].indexOf(value) !== -1,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md"].indexOf(value) !== -1,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorClass() {
      const colorMap = {
        primary: this.dark ? "tw-bg-primary-600 tw-text-primary-100" : "tw-bg-primary-100 tw-text-primary-600",
        secondary: this.dark ? "tw-bg-secondary-600 tw-text-secondary-100" : "tw-bg-secondary-100 tw-text-secondary-600",
        green: this.dark ? "tw-bg-green-600 tw-text-green-100" : "tw-bg-green-100 tw-text-green-600",
        red: this.dark ? "tw-bg-red-600 tw-text-red-100" : "tw-bg-red-100 tw-text-red-600",
        yellow: this.dark ? "tw-bg-yellow-600 tw-text-yellow-100" : "tw-bg-yellow-100 tw-text-yellow-600",
        gray: this.dark ? "tw-bg-gray-600 tw-text-gray-100" : "tw-bg-gray-100 tw-text-gray-600",
      };
      return colorMap[this.color] || colorMap.primary;
    },
    sizeClass() {
      let returnClass = "";

      switch (this.size) {
        case "xs":
          returnClass = "tw-px-1.5 tw-py-0.4 tw-text-xxs tw-leading-4";
          break;
        case "sm":
          returnClass = "tw-px-2.5 tw-py-0.5 tw-text-xs tw-leading-4";
          break;
        case "md":
          returnClass = "tw-px-3 tw-py-0.5 tw-text-sm tw-leading-5";
          break;
        default:
          returnClass = "tw-px-3 tw-py-0.5 tw-text-sm tw-leading-5";
          break;
      }
      return returnClass;
    },
  },
};
</script>
<style scoped>
.tw-text-xxs {
  font-size: 0.7rem;
}
</style>
